const BREAKPOINTS = {
    '0': {
        slidesPerView: 1,
        spaceBetween: 0,
    },
    '500': {
        slidesPerView: 4,
        spaceBetween: 0,
    },
    '600': {
        slidesPerView: 4,
        spaceBetween: 0,
    },
    '1024': {
        slidesPerView: 4,
        spaceBetween: 0,
    },
    '1280': {
        slidesPerView: 4.5,
        spaceBetween: 0,
    },
    '1920': {
        slidesPerView: 5,
        spaceBetween: 0,
    },
}

const FILTERS = {
    animals: [
        "LA_GRANJITA",
        "SELVAPLUS",
        "GUACHARO",
        "LOTTOREY",
        "CHANCEANIMAL",
        "LOTTOACTIVO",
        "FRUITAGANA",
         "COMBINAFT",
        "GRANJAZO",
        "GRANJAMILLO_ANI",
         "CONDORGANA",
        "TROPIGANA"
    ],
    zodiacal: ["SUPERGANA_SIG", "TACHIRA_SIG", "TRIPLEGANA_SIG", "CHANCE_SIG"],
    lottery: ["TRINAPA", "CENTENAP", "TER_GRANJITA", "TERMINALITO", "RICACHONA", "TER_RICACHO", "TACHIRA", "CHANCE", "COLOMBIANA", "USA",]
}

module.exports = { BREAKPOINTS, FILTERS }